import { asyncRoutes, constantRoutes } from "@/router";

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
// eslint-disable-next-line no-unused-vars
function hasPermission(roles, route) {
  // console.log(roles);
  // console.log(route);
  // if (route.code) {
  // return roles.some(function() {
  // () => roles.includes(route.code)
  // let key =
  //   roles.includes(route.code) ||
  //   roles.includes(route.code.replace("P_", ""));
  // console.log(key);
  // return key;
  // });
  // } else {
  return true;
  // }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = [];
  // console.log(routes);
  // console.log(roles);
  routes.forEach(route => {
    // console.log(route);
    const tmp = { ...route };

    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });
  return res;
}

const state = {
  routes: [],
  addRoutes: []
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
    // console.log(state.routes);
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  generateRoutes({ commit }, roles) {
    // eslint-disable-next-line no-unused-vars
    return new Promise(resolve => {
      let accessedRoutes,
        listN = [];
      // if (roles.includes("admin")) {
      //   accessedRoutes = asyncRoutes || [];
      // } else {
      // console.log(asyncRoutes);
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);

      // console.log(accessedRoutes);
      listN = [].concat(accessedRoutes);
      commit("SET_ROUTES", accessedRoutes);

      var new_arr = [];
      var json_arr = [];
      for (var i = 0; i < listN.length; i++) {
        // console.log(new_arr.indexOf(arr[i][attribute]));
        if (new_arr.indexOf(listN[i].code) == -1) {
          //  -1代表没有找到
          new_arr.push(listN[i].code); //如果没有找到就把这个name放到arr里面，以便下次循环时用
          json_arr.push(listN[i]);
        }
      }

      resolve(json_arr);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
